export const kratos_verification_flow = {
  instructions: "Enter the verification code from your email.",
  verification_failed: "Verification failed.",
  cta_resend_code: "Send a new code",
  resend_help: "Need a fresh code?",
};
